module.exports = '<svg width="20" height="32" viewBox="0 0 20 32"><path d="M0 10c0 2.25.41 3.742 1.996 5.996 1.388 1.972 3.414 4.644 3.896 7.012.112.54.556.992 1.108.992h6c.552 0 .996-.452 1.108-.992.482-2.368 2.508-5.04 3.896-7.012C19.59 13.742 20 12.25 20 10c0-5.524-4.476-10-10-10S0 4.476 0 10zm8 20v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1h1a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h1z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/lightbulb-1.js
// module id = 1230
// module chunks = 14